module.exports = __webpack_public_path__ + "static/Inter-Bold-100b5c823c0c34f1e641a7ccdb963668.woff";